import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import { getAttendanceStatistics } from '@/service/operate/comprehensiveDaily';
export default function useAttendance(attendanceParams) {
  var attendanceTotal = ref({
    no_sign_count: 0,
    leave_count: 0,
    leave_days_count: 0,
    leave_early_count: 0,
    require_count: 0,
    absent_count: 0,
    late_count: 0,
    attendance_count: 0,
    absent_from_work: 0
  });
  // 查询时间范围内停机详情
  var getAttendanceAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAttendanceStatistics(attendanceParams.value);
          case 2:
            data = _context.sent;
            attendanceTotal.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAttendanceAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var attendanceData = computed(function () {
    return [
    // {
    //   num: attendanceTotal.value.require_count,
    //   desc: '总考勤人数'
    // },
    {
      num: attendanceTotal.value.attendance_count,
      desc: '已打卡人数'
    }, {
      num: attendanceTotal.value.absent_count,
      desc: '未打卡人数'
    }, {
      num: attendanceTotal.value.late_count,
      desc: '迟到'
    }, {
      num: attendanceTotal.value.leave_early_count,
      desc: '早退'
    }, {
      num: attendanceTotal.value.leave_count,
      desc: '请假'
    }];
  });
  var require_count = computed(function () {
    return attendanceTotal.value.require_count;
  });
  var attendaceEchartData = computed(function () {
    return {
      pieData: attendanceData.value.map(function (item) {
        return {
          name: item.desc,
          value: item.num
        };
      }).sort(function (a, b) {
        return b.value - a.value;
      }),
      unit: '人',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        console.log('params', params);
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "\u4EBA</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      },
      height: '100%',
      radius: [60, 80],
      labelShow: false
    };
  });
  return [require_count, attendanceData, getAttendanceAsync, attendaceEchartData];
}